module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m9-870d97811e47a59994d288d07efcbdf3.png";